import './Text.css';



export function MajorMinorFair() {
  return (
    <div class="body">



<div class="row" id="GalleryThree">
  <div class="column" >   
                      <h4>Major Minor Fair 2024
            <br/><br/>
            Wayfinding Posters.<br/>Web Gifs.
                </h4>
                </div>
</div>
<div class="row">
<div class="column">       
        <img  src="2024_MajorMinorFairIntranetGraphic_Optimized-PC.gif"></img>
</div>
<div class="column">
        <img  src="MMF_Mockup_Stanchion_02.jpg"></img>
</div>
<div class="column">
        <img  src="2024_MajMinFair_Stanchion__Page_1.png"></img>  
</div>
<div class="column">
        <img  src="2024_MajMinFair_Stanchion__Page_2.png"></img>
  </div>
<div class="column">
        <img  src="2024_MajMinFair_Stanchion__Page_3.png"></img>
</div>
<div class="column">
        <img  src="2024_MajMinFair_Stanchion__Page_4.png"></img>
</div>
<div class="column">
        <img  src="2024_MajMinFair_Stanchion__Page_5.png"></img>
</div>
<div class="column">
        <img  src="2024_MajMinFair_Stanchion__Page_6.png"></img>
</div>
<div class="column">
        <img  src="2024_MajMinFair_Stanchion__Page_7.png"></img>
</div>
        </div>
        
        </div>




  );
}
